<template>
  <div
    id="cookie-popup"
    class="cookie-popup__background"
    :style="{ display: visible ? 'grid' : 'none' }"
  >
    <div v-if="step === 1" class="cookie-popup">
      <div class="cookie-popup__title h2">
        {{ tr("client.cookies.title") }}
      </div>
      <div
        v-html="
          tr('client.cookies.summary', {
            domain,
            privacySlug: ziggyUnsafe('client.about.privacy'),
          })
        "
      />
      <div class="cookie-popup__buttons cookie-popup__buttons--step-1">
        <button
          class="cookie-popup__button cookie-popup__button__primary"
          type="button"
          @click="acceptClick"
        >
          {{ tr("client.cookies.accept_all") }}
        </button>
        <button
          class="cookie-popup__button cookie-popup__button__secondary"
          type="button"
          @click="step = 2"
        >
          {{ tr("client.cookies.settings") }}
        </button>
      </div>
    </div>

    <form
      v-if="step === 2"
      class="cookie-popup cookie-popup__step-2"
      :style="{ display: 'block' }"
      @submit.prevent="submitCustom"
    >
      <div class="cookie-popup__title h2">
        {{ tr("client.cookies.settings") }}
      </div>
      <div
        v-html="
          tr('client.cookies.settings_summary', {
            privacySlug: ziggyUnsafe('client.about.privacy'),
          })
        "
      />

      <label
        class="cookie-popup__option cookie-popup__option--disabled cookie-popup__option--checked"
      >
        <input
          checked
          class="cookie-popup__option__input"
          disabled
          name="cookie-setting"
          type="checkbox"
          value="functionality_storage"
        />
        <i class="fas fa-check cookie-popup__option__icon" />
        <span class="cookie-popup__option__title">
          {{ tr("client.cookies.functionality_title") }}
        </span>
        <span class="cookie-popup__option__description">
          {{ tr("client.cookies.functionality_explanation") }}
        </span>
      </label>

      <label
        class="cookie-popup__option"
        :class="{ 'cookie-popup__option--checked': analyticsStorage }"
      >
        <input
          v-model="analyticsStorage"
          class="cookie-popup__option__input"
          name="cookie-setting"
          type="checkbox"
          value="analytics_storage"
        />
        <i class="fas fa-check cookie-popup__option__icon" />
        <span class="cookie-popup__option__title">
          {{ tr("client.cookies.analytics_title") }}
        </span>
        <span class="cookie-popup__option__description">
          {{ tr("client.cookies.analytics_explanation") }}
        </span>
      </label>

      <label
        class="cookie-popup__option"
        :class="{ 'cookie-popup__option--checked': adStorage }"
      >
        <input
          v-model="adStorage"
          class="cookie-popup__option__input"
          name="cookie-setting"
          type="checkbox"
          value="ad_storage"
        />
        <i class="fas fa-check cookie-popup__option__icon" />
        <span class="cookie-popup__option__title">{{
          tr("client.cookies.ad_title")
        }}</span>
        <span class="cookie-popup__option__description">{{
          tr("client.cookies.ad_explanation")
        }}</span>
      </label>

      <div class="cookie-popup__buttons cookie-popup__buttons--step-2">
        <button
          class="cookie-popup__button cookie-popup__button__secondary"
          type="button"
          @click="acceptClick"
        >
          {{ tr("client.cookies.accept_all") }}
        </button>
        <button
          class="cookie-popup__button cookie-popup__button__primary"
          type="submit"
        >
          {{ tr("client.cookies.accept_custom") }}
        </button>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import { ziggyUnsafe } from "@solvari/common-fe/integrations";
import { useI18nMainSiteCookies } from "@solvari/translations";

import { useCookiePopup } from "./useCookiePopup.ts";

/*
  This component is a little weird. It has to be partially handled outside vue.
  The styling also needs to be compatible with the blade version.
 */

defineProps<{ domain: string }>();

const { tr } = useI18nMainSiteCookies();

const {
  visible,
  step,
  analyticsStorage,
  adStorage,
  acceptClick,
  submitCustom,
} = useCookiePopup();
</script>

<style lang="postcss">
/* @import, not src=: src= keeps the .css module id and vitalizer leaves the <link>. */
@import "./sCookiePopup.css";
</style>
